import { type GetHookResponse } from '../hooks'
import { teamDownlineKey } from '../keys'
import { useTantalimQuery } from '../query'
import { useUserCache } from '../user/cache'
import {
  type CompanyId,
  HOUR,
  Logger,
  type TeamDownlineInput,
  type TeamDownlineSuccess,
  type TeamId,
  type TinyUser,
} from '@terros/common'

const logger = new Logger('useTeam')

export function useTeamDownline(entityId: TeamId | CompanyId | undefined, enabled = true): GetHookResponse<TinyUser[]> {
  logger.verbose('calling useTeamDownline', entityId)
  const cache = useUserCache()
  const resolvedTeamId = entityId ?? 'Team:NOT_PROVIDED'
  return useTantalimQuery<TeamDownlineInput, TeamDownlineSuccess, TinyUser[]>({
    url: '/team/downline',
    queryKey: teamDownlineKey(resolvedTeamId),
    input: {
      entityId: resolvedTeamId,
    },
    convertResponse: ({ users }) => {
      users.forEach((user) => cache.setTinyUser(user))
      return users
    },
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      enabled: Boolean(entityId) && enabled,
    },
  })
}
